// extracted by mini-css-extract-plugin
var _1 = "_Kjcxt";
var _2 = "_ZJrGa";
var _3 = "_CQz2K";
var _4 = "_znQGw";
var _5 = "_QotNV";
export { _1 as "textarea", _2 as "textareaDisabled", _3 as "textareaError", _4 as "textareaLabel", _5 as "textareaWrapper" }
